module.exports = __webpack_public_path__ + "static/media/vis6.56f83045.jpeg";